Ext.define('SA.model.LocationValue.SeriesCacheConformant', {
    extend: 'SA.model.LocationValue',

    statics: {
        isConformantValue(value) {
            var object = SA.Object.of(value);

            return object && object.keysAre(SA.data.LocationsCache.ItemKeys);
        }
    },

    getId() {
        return this.value.locationSeries;
    }
});